module.exports = __webpack_public_path__ + "img/dylan2.f946771d.jpg";